import React, { type CSSProperties } from 'react'
import { Trans } from '@lingui/macro'

import classes from './ReconnectButton.module.scss'

type ReconnectButtonProps = {
  isReady: boolean
  secondsLeft: number
  ctaButtonStyle?: CSSProperties
  goBack: () => void
}

export const ReconnectButton = (props: ReconnectButtonProps) => {
  const { isReady, secondsLeft, goBack, ctaButtonStyle } = props

  return (
    <div className={classes.Buttons}>
      <button
        className={classes.ReconnectButton}
        style={ctaButtonStyle}
        onClick={isReady ? goBack : undefined}
        disabled={!isReady}
      >
        {isReady ? (
          <Trans>Reconnect now</Trans>
        ) : (
          <Trans values={{ secondsLeft }}>
            Reconnecting in {secondsLeft} seconds...
          </Trans>
        )}
      </button>
    </div>
  )
}
